(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Splide('#testimonial-slider', {
    type: 'loop',
    perPage: 4,
    gap: '20px',
    arrows: false,
    pagination: false,
    breakpoints: {
      1440: {
        perPage: 4
      },
      1024: {
        perPage: 3
      },
      768: {
        arrows: true,
        gap: '15px',
        focus     : 'center',
        pagination: true,
        perPage: 1
      }
    }
  }).mount();
});

  } catch(e) { console.error(e); }
})();
})();
